<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="container">
      <!-- 头部标题 -->
      <div class="banner-box">
        <div class="banner-title">轻骑兵低代码开发平台</div>
        <div class="banner-text">
          覆盖各行业、各种应用场景的成熟应用，给您更多的选择
        </div>
        <div class="banner-add" @click="uploadApplication">
          <div class="imgs">
            <img src="../assets/img/MallPhonePage/add.png" />
          </div>
          <div class="text">
            <div>上传我的应用</div>
          </div>
        </div>
      </div>
      <!-- 通用性应用 -->
      <div class="app-box">
        <div class="app-title">通用性应用</div>
        <div
          v-for="(item, index) in universalAppList.slice(
            (currentPage - 1) * pageSize,
            currentPage * pageSize
          )"
          :key="index"
          :class="{
            'app-item': true,
            'app-item-isHot': item.isHot,
            'app-item-isNotHot': !item.isHot,
          }"
        >
          <div class="item-title">{{ item.title }}</div>
          <div class="item-icon">
            <div class="icon" v-for="(icon, index) in item.tag" :key="index">
              {{ icon }}
            </div>
          </div>
          <div class="item-text">{{ item.desc }}</div>
          <van-button
            round
            type="info"
            size="small"
            class="item-button"
            @click="consultNow(item.title)"
            >立即咨询</van-button
          >
        </div>
        <div class="pagination">
          <van-pagination
            v-model="currentPage"
            :page-count="pageTotal"
            @change="changePage"
            :total-items="pageTotal"
          >
            <template #prev-text>
              <van-icon name="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
            <template #page="{ text }">{{ text }}</template>
          </van-pagination>
        </div>
      </div>
      <!-- 行业应用 -->
      <div class="industry-box">
        <div class="industry-title">行业应用</div>
        <el-collapse
          v-model="activeName"
          accordion
          class="collapseList"
          @change="handleChange"
        >
          <el-collapse-item
            v-for="(item, index) in collapseList"
            :key="item.id"
            :name="item.id"
            ><template slot="title">
              <img
                :src="
                  index === activeIndex - 1 && activeIndex !== ''
                    ? item.iconActive
                    : item.icon
                "
                style="height: 30px; margin: 0 10px"
              /><span class="collapse-title">{{ item.title }}</span>
            </template>
            <div
              v-for="(items, index) in item.item"
              :key="index"
              class="collapse-item"
              @click="consultNow(items)"
            >
              <div class="collapse-content">
                <div class="collapse-title-items">{{ items }}</div>
                <img src="../assets/img/MallPhonePage/collapse-item.png" />
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="upload" @click="uploadApplication">
        <van-button plain type="info">+上传我的应用</van-button>
      </div>
    </div>
    <!-- 表单提交后的popup -->
    <van-popup
      id="afterPracticePopup"
      v-model="afterPracticeMenuShow"
      closeable
      round
      position="bottom"
      @close="handleAfterClosePop"
    >
      <div class="bg">
        <img src="../assets/img/phoneHomePage/afterPop.png" />
      </div>
      <div class="context">
        <div class="title">提交成功</div>
        <div class="text">我们会在3个工作日内与您联系，请注意接听来电</div>
        <van-button type="info" @click="handleAfterClosePop">好的</van-button>
      </div>
    </van-popup>
    <!-- 上传我的应用 -->
    <Upload
      v-if="showUploadForm"
      @closeUploadForm="closeUploadForm"
      @openAfterPracticeMenu="openAfterPracticeMenu"
    ></Upload>
    <!-- 立即咨询 -->
    <ExperienceNowForMall
      v-if="showExperienceNowForMall"
      @closeExperienceNowForMall="closeExperienceNowForMall"
      @openExperienceNowForMall="openAfterPracticeMenu"
      :consult="consultData"
    ></ExperienceNowForMall>
    <!-- 公司信息 -->
    <CompanyInformation @changePracticeMenuShow="handleOpenPractice">
    </CompanyInformation>
    <!-- 右侧菜单 -->
    <RightMenu
      :isMenuShow="isMenuShow"
      @rightMenuShow="handleRightMenuShow"
    ></RightMenu>
    <!-- 底部立即体验弹出 -->
    <ExperienceNow
      :isPopShow="isPopShow"
      @CloseExperienceNow="handleCloseExperienceNow"
    ></ExperienceNow>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import CompanyInformation from "./include/CompanyInformation.vue";
import RightMenu from "./include/RightMenu.vue";
import ExperienceNow from "./include/ExperienceNow.vue";
import Upload from "./include/Upload.vue";
import ExperienceNowForMall from "./include/ExperienceNowForMall.vue";
export default {
  name: "HussarHomePhonePage",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
    Upload,
    ExperienceNowForMall,
  },
  data() {
    return {
      showExperienceNowForMall: false,
      afterPracticeMenuShow: false,
      isMenuShow: false,
      isPopShow: false,
      universalAppList: [
        {
          title: "干部管理",
          isHot: true,
          tag: ["干部画像", "干部调整", "干部测评"],
          desc: "打造“选、育、管、用”全流程的数字化平台，为精准识人，科学选人、严格用人提供有力支撑。",
        },
        {
          title: "智能运维",
          isHot: true,
          tag: ["故障排查", "业务软件深度监控", "多机房监控"],
          desc: "帮助运维人员管理机房，对机房内的软件系统和硬件设备实现自动化监控，可定期生成巡检报告，实现故障预警、定位，降低故障发生率。",
        },
        {
          title: "知识库",
          isHot: false,
          tag: ["企业知识收集", "企业数据资产管理"],
          desc: "数据资产管理系统，融合知识图谱，自然语言处理，ES检索等技术，助力企业从数据中提取知识，沉淀数据资产，实现对企业知识的智能检索、问答、推荐和统一管理。",
        },
        {
          title: "即时通讯",
          isHot: false,
          tag: ["新一代企业数字化OA", "移动门户"],
          desc: "一款类微信的即时通讯产品，支持在内搭建服务器，独立部署使用，确保交流信息的安全可控。支持移动门户的快速搭建，助力政企机构高效构建新一代数字化移动办公生态。",
        },
        {
          title: "业务拨测平台",
          isHot: true,
          tag: ["自动化业务探测", "异常告警精准推送"],
          desc: "可以模拟用户真实访问系统，7*24小时主动探测核心功能的可用性，发现问题及时告警，以便运维人员及时止损；为业务系统建立一道用户侧防线，减轻业务系统运维压力。",
        },
        {
          title: "企业经营数字化管控平台",
          isHot: false,
          tag: ["企业经营数据分析", "企业流程管理"],
          desc: "是以年度预算全面达成为目标，实现各业务指标的多维分析、进度完成率的提醒预警、经营管理的深度优化、最终实现经营管理过程中的风险管控、降本增效、开源节流。",
        },
        {
          title: "合同管理系统",
          isHot: false,
          tag: ["合同电子化", "合同标准化"],
          desc: "提供合同全生命周期管理一站式平台，实现审批流程可追溯、签订过程规范化、执行过程透明化，提高合同起草效率，支持在线签章，保证合同安全。",
        },
        {
          title: "招标采购全流程数字化平台",
          isHot: true,
          tag: ["计划管理", "采购管理", "供应商管理"],
          desc: "平台通过建立标准化的招标采购业务流程，实现招标采购 “业务公开、过程受控、全程在案、永久追溯”，有效防止人为干预，保障招标采购过程合法合规，实现降本增效。",
        },
        {
          title: "实验室管理系统",
          isHot: true,
          tag: ["CNAS全要素覆盖", "报告样式自定义"],
          desc: "一套符合ISO/IEC17025规范并有效帮助实验室进行CNAS评审和复审的实验室管理系统（LIMS）。",
        },
        {
          title: "电子实验记录本",
          isHot: true,
          tag: ["自动生成实验报告", "盘活实验数据"],
          desc: "一款支持用户自定义的实验记录本，用于解决企业实验室存在大量实验模板且经常需要调整；实验员依靠传统纸质材料填写实验记录，效率低、易出错；实验数据停难以有效利用等问题。",
        },
        {
          title: "满天星应用托管分发平台",
          isHot: false,
          tag: ["应用分发", "应用版本管理"],
          desc: "是一款企业级应用管理平台，可以为企业构建统一的应用分发、管理服务。方便用户查找、安装、升级应用，帮助企业统计每个应用的下载及使用情况。",
        },
        {
          title: "智慧人力资源管理平台",
          isHot: false,
          tag: ["HR业务全覆盖", "人力资源管理"],
          desc: "聚焦人力资源管理痛点，着力解决人力资源管理信息分散、业务模块间有效关联度差、管理手段落后、信息整合和自动生成效率低等问题。",
        },
        {
          title: "评标专家监管系统",
          isHot: false,
          tag: ["评标专家监管系统", "自动考勤"],
          desc: "利用物联网技术，结合人脸识别、智能手环等设备，实现专家的自助报到、自动考勤、实时监控，从而提升入场离场效率，降低评标组织、服务保障、监察的人力成本。",
        },
        {
          title: "智能仓储管理系统",
          isHot: true,
          tag: ["物料管理精细化", "仓储作业无纸化"],
          desc: "运用RFID物联网技术，实现仓储作业的快速办理，降低仓库作业出错率、库存更加准确，实现仓库实时化、高效化、合理化管理。",
        },
        {
          title: "智能生产管理系统",
          isHot: false,
          tag: ["生产过程透明化", "生产管理标准化"],
          desc: "面向企业车间执行层，实现从订单下达到产品出库的全过程管理，构建产品质量管理体系，实现质量追溯，实现生产过程的透明化，提升管理层决策效率。",
        },
        {
          title: "化工行业HSE管理平台",
          isHot: true,
          tag: ["规范各项安全管理", "提高HSE水平管理"],
          desc: "以《HSE管理体系》所要求的10大要素为建设依据，并全面覆盖国家安全生产标准化的评审标准，可有效帮助企业规范各项安全管理工作，提升HSE管理水平，降低事故发生。",
        },
        {
          title: "化工行业承包商",
          isHot: false,
          tag: ["数字化移动考试", "试证合一"],
          desc: "以《安全生产法》和《企业安全生产标准化基本规范》中关于承包商入厂考试的要求为建设依据，包括承包商及人员管理、题库维护、试卷维护、在线考试、成绩台账等5个业务模块。",
        },
        {
          title: "特殊作业票管理系统",
          isHot: true,
          tag: ["拖拉拽绘制作业票", "作业全流程管控"],
          desc: "提供票面可视化编辑器，支持用户通过拖拉拽的方式自定义编辑作业票票面及流程内置8大特殊作业票面，符合国标要求，实现预约、申请、审批到验收归档的全过程数字化，规范化管理。",
        },
      ],
      currentPage: 1, // 当前页
      pageTotal: 1, // 总页数
      pageSize: 8, // 每页显示个数
      activeName: ["1"], // 默认激活的面板
      activeIndex: 1, // 激活的面板index
      showUploadForm: false,
      collapseList: [
        {
          id: "1",
          title: "电力",
          icon: require("../assets/img/MallPhonePage/collapse1.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse1-h.png"),
          item: [
            "低压台区终端指标计算系统",
            "重大活动供电保障管理系统",
            "移动智能点巡检系统",
            "火电厂性能诊断平台",
            "新能源发电企业物资管理系统",
            "新能源安健环管理平台",
          ],
        },
        {
          id: "2",
          title: "轨道",
          icon: require("../assets/img/MallPhonePage/collapse2.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse2-h.png"),
          item: [
            "桥梁及钢轨位移远程监测系统",
            "城轨运检一体化智能管理平台",
            "自动化部署管家",
            "利刃综合数据管理平台",
          ],
        },
        {
          id: "3",
          title: "石化",
          icon: require("../assets/img/MallPhonePage/collapse3.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse3-h.png"),
          item: [
            "化工行业电子作业票系统",
            "安全风险评估管理平台",
            "化工行业承包商入厂考试系统",
            "化工行业承包商管理平台",
            "化工行业HSE管理系统",
            "化工行业应急指挥平台",
          ],
        },
        {
          id: "4",
          title: "政府",
          icon: require("../assets/img/MallPhonePage/collapse4.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse4-h.png"),
          item: [
            "科技管理一站式解决方案",
            "绩效考核管理系统",
            "社会矛盾纠纷调处化解平台",
            "应急指挥技术支撑系统",
            "退役军人综合服务平台",
            "智慧党建",
          ],
        },
        {
          id: "5",
          title: "工程",
          icon: require("../assets/img/MallPhonePage/collapse5.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse5-h.png"),
          item: [
            "工程目标管理系统",
            "工程施工分包管理部门",
            "工程成本管理系统",
            "工程项目隐患排查治理系统",
            "工程物资管理系统",
            "工程验收量化系统",
          ],
        },
        {
          id: "6",
          title: "制造",
          icon: require("../assets/img/MallPhonePage/collapse6.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse6-h.png"),
          item: ["制造业智能生产管理系统", "智能仓储管理系统"],
        },
        {
          id: "7",
          title: "生物医药",
          icon: require("../assets/img/MallPhonePage/collapse7.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse7-h.png"),
          item: [
            "数字化药企解决方案",
            "实验室信息管理系统",
            "智能仓储管理系统",
            "制造业只能生产管理系统",
          ],
        },
        {
          id: "8",
          title: "其他",
          icon: require("../assets/img/MallPhonePage/collapse8.png"),
          iconActive: require("../assets/img/MallPhonePage/collapse8-h.png"),
          item: ["保险销售支持平台", "智慧共享图书", "培训考试平台", "易学习"],
        },
      ],
      consultData: "",
    };
  },
  watch: {},
  methods: {
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
    // 分页后页面滚动
    changePage() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    // 计算分页数
    getPageTotal() {
      this.pageTotal = Math.ceil(this.universalAppList.length / this.pageSize);
      this.pageTotal = this.pageTotal === 0 ? 1 : this.pageTotal;
    },
    // 切换行业应用
    handleChange(val) {
      this.activeIndex = val;
    },
    // 上传我的应用
    uploadApplication() {
      this.showUploadForm = true;
    },
    // 关闭上传我的应用
    closeUploadForm() {
      this.showUploadForm = false;
    },
    // 立即咨询
    consultNow(data) {
      this.consultData = data;
      this.showExperienceNowForMall = true;
    },
    // 关闭立即咨询
    closeExperienceNowForMall() {
      this.showExperienceNowForMall = false;
    },
    // 打开提交成功
    openAfterPracticeMenu() {
      this.afterPracticeMenuShow = true;
    },
    // 关闭提交成功
    handleAfterClosePop() {
      this.afterPracticeMenuShow = false;
    },
  },
  mounted() {
    this.getPageTotal();
  },
};
</script>

<style scoped>
.container {
  margin-top: 53px;
  /* width: 100%; */
}
/* 头部标题 */
.banner-box {
  background: url("../assets/img/MallPhonePage/banner-bg.png") no-repeat;
  background-size: cover;
  padding: 60px 0 40px 0;
}
.banner-title {
  color: #fff;
  font-size: 0.55rem;
  display: flex;
  justify-content: center;
  font-weight: 600;
}
.banner-text {
  font-size: 0.25rem;
  color: #fff;
  display: flex;
  justify-content: center;
  font-weight: 500;
  line-height: 50px;
}
.banner-add {
  margin-top: 60px;
}
.banner-add > .imgs {
  display: flex;
  justify-content: center;
}
.banner-add > .imgs > img {
  height: 55px;
}
.banner-add > .text {
  display: flex;
  justify-content: center;
}
.banner-add > .text > div {
  font-size: 15px;
  font-weight: 500;
  line-height: 50px;
  color: #f19f35;
}
/* 头部标题end */
/* 通用性应用 */
.app-box {
  padding: 60px 10px;
}
.app-title {
  display: flex;
  justify-content: center;
  font-size: 0.5rem;
  color: #000;
  font-weight: 600;
  padding-bottom: 30px;
}
.app-item {
  position: relative;
  width: 100%;
  padding: 30px 25px 20px 25px;
  margin-bottom: 20px;
}
.app-item-isHot {
  background: url("../assets/img/MallPhonePage/isHot.png");
  background-size: cover;
}
.app-item-isNotHot {
  background: url("../assets/img/MallPhonePage/isNotHot.png");
  background-size: cover;
}
.app-item .item-title {
  font-size: 0.4rem;
  font-weight: 500;
  color: #2e2e2e;
}
.app-item .item-icon {
  display: flex;
  justify-content: left;
  margin: 10px 0;
}
.app-item .item-icon > .icon {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  background-color: #c1d9ff;
  padding: 2px 7px;
  margin-right: 10px;
  border-radius: 5px;
}
.app-item .item-text {
  height: 140px;
  font-size: 16px;
  color: #2e2e2e;
  padding-top: 15px;
  font-weight: 400;
}
.app-item .item-button {
  position: relative;
  left: 75%;
  width: 90px;
  font-size: 15px;
}
.pagination {
  display: flex;
  justify-content: center;
}
.pagination > .van-pagination {
  width: 200px;
}
/* 通用性应用end */
/* 行业应用 */
.industry-title {
  display: flex;
  justify-content: center;
  font-size: 0.5rem;
  color: #000;
  font-weight: 600;
  padding-bottom: 20px;
}
.collapseList {
  padding: 0 20px 20px 20px;
  border: none;
}
.collapse-title {
  font-size: 18px;
  font-weight: 500;
}
.collapse-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px 0 15px;
}
.collapse-title-items {
  font-size: 16px;
}
.collapse-content > img {
  height: 20px;
}
/deep/ .el-collapse-item {
  margin: 15px 0;
}
/deep/ .el-collapse-item__header {
  background-image: linear-gradient(to right, #fff, #e8f2ff);
  border: none;
}
/deep/ .el-collapse-item__header.is-active {
  background-image: linear-gradient(to right, #018dff, #1a74f1);
  color: #fff;
}
/deep/ .el-collapse-item__wrap {
  background: #fafcff;
  border: none;
}
/* 行业应用end */
.upload {
  display: flex;
  justify-content: center;
  padding: 20px 20px 40px 20px;
}
.upload > .van-button {
  height: 40px;
  width: 130px;
}

/* 提交成功弹窗 */

#afterPracticePopup .bg {
  margin: 40px 0 20px 0;
  text-align: center;
}
#afterPracticePopup .bg > img {
  height: 70px;
}
#afterPracticePopup .context {
  text-align: center;
}
#afterPracticePopup .context .title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}
#afterPracticePopup .context .text {
  font-size: 14px;
  margin-bottom: 30px;
}
#afterPracticePopup .context .van-button {
  width: 90%;
  font-size: 14px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/MallPhonePage.vue